import { File } from '../file';
import { InternVideoMeta } from '../intern/video-meta';
import { ContentIntro } from './intro';

/**
 * Model definition for Video
 */
export interface ContentVideo {
  __component: 'content.video';
  id: string;
  intro?: ContentIntro;
  kind?: 'youtube' | 'mediacenter';
  video: string;
  thumbnail?: File;
  meta?: InternVideoMeta;
  additionalData?: { [key: string]: unknown };
}

export function isContentVideo(obj: { __component?: string }): obj is ContentVideo {
  return obj.__component === 'content.video';
}
